import React from 'react';
import Button from './Button';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPage: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onPage }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="mt-4 flex justify-center items-center gap-4">
      <Button
        variant="borderlike"
        disabled={currentPage === 0}
        onClick={() => onPage(Math.max(currentPage - 1, 0))}
      >
        Previous
      </Button>

      <span className="text-sm">
        Page {currentPage + 1} of {totalPages}
      </span>

      <Button
        variant="active"
        disabled={currentPage === totalPages - 1}
        onClick={() => onPage(Math.min(currentPage + 1, totalPages - 1))}
      >
        Next
      </Button>
    </div>
  );
}
